import { useReducer, useRef, useState, useEffect, useLayoutEffect } from "react";
import { Form, Col, Stack, Collapse, Fade, Button } from 'react-bootstrap';
import { TextButton } from 'Components/Button';
import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import { ACTIONS } from "Components/Forms/FormReducers/TextInputReducer";
import ItemCommentCount from './ItemCommentCount';
import { commentsMatch, getCommentTempInputData, getErrorList, getFormattedDate, logS, validateCommentAPI } from "../Util/Utilities";
import { displayErrors } from "Components/Messages/ErrorMessage";
import { ERROR_MESSAGES } from "Utils/constants";
import { config } from "Utils/config";

function ItemComment({ 
    eventKey,
    handleActiveCommentChange, 
    tempCommentList, tempCommentListDispatch, 
    activeCommentKey, setActiveCommentKey, 
    item, 
    inputVisible, setInputVisible, 
    commentsList, commentsListDispatch, 
    isArrItem, 
    mobile,
    categoryId,handleStatusClose,setStatusData,setStatusVariant,setShowStatusPopup
}) {
    const [event, setEvent] = useState(item);
    const [arrItem, setArrItem] = useState(isArrItem);
    
    const [commentState, setCommentState] = useState('none'); //none, add, edit, view
    const [showControls, setShowControls] = useState(false); 
    
    //Load any previously saved comment data from commentsList
    const commentData = commentsList.hasOwnProperty(event.id) ? commentsList[event.id] : null;

    var itemInputObj = {
        type: 'textarea',
        id: event.id,
        name: event.id,
        value: '',
        count: "".substring(0,2000).length,
        display: {
            label: event.itemNum,
            description: null,
            title: event.itemName,
            placeholder: event.itemName,
            maxLength: 2000,
            rows: 10,
            cols: 90,
            hasCounter: true
        },
        validation: {
            required: true,
            isInvalid: false,
            errors: [],
            isValid: false,
            successMsgs: []
        },
        disabled: false,
        readOnly: false,
        InputRef: useRef(null),
        EditRef: useRef(null),
        ErrorRef: useRef(null)
    };

    useEffect(()=>{
        var d = getCommentTempInputData(tempCommentList,event.id,"status");
        if(d!=null){
            setCommentState(d);
            setInputVisible(true);
        }
        if(activeCommentKey==event.id){
            if(d!=null){
                setCommentState(d);
                setInputVisible(true);
            }
        }
    },[tempCommentList])
    
    useEffect(()=>{
        var d = getCommentTempInputData(tempCommentList,event.id,"status");
        if(d!=null){
            setCommentState(d);
            setInputVisible(true);
        }
        else{
            const commentData = commentsList.hasOwnProperty(event.id) ? commentsList[event.id] : null;
            if(activeCommentKey==event.id){
                setInputVisible(true);
                tempCommentListDispatch({
                    type: "add-comment",
                    input: commentData!=null ? commentData.input : itemInputObj, // If existing comment, load comment input data. otherwise use new input object element (defined above)
                    item: event,
                    date: new Date(),
                    status: commentData!=null ? "view" : "add"
                })
            }
        }
    },[activeCommentKey])


    const handleInputTextAreaChange = (e) => {
        tempCommentListDispatch({
            type: ACTIONS.TEXT_AREA_CHANGE,
            value: e.target.value,
            maxLength: 2000,
            name: e.target.name
        });
    }

    const validate = (text,category,itemId, generalComment, domId, checkEmpty) => {
        //var r = [];//validateCommentText(value);
        validateCommentAPI(text,category,itemId, generalComment, domId).then(res => {
            var r = [];
            config.isDebugEnabled && console.log(res);
            if(res?.data){
                var codes = res.data.errorCodeList;
                var messages = res.data.errorMessageList;
                for(var x = 0 ; x<codes.length ; x++){
                    var c = codes[x];
                    if(c!=null){
                        var split = c.split("_");
                        
                        if(split.length>1){
                            
                                r.push({code: split[1], msg: messages[x]});
                            
                            
                        }
                    }
                    
                }
            }
            if(r!=null && r.length>0){
                var arr = [];
                for(var x = 0 ; x<r.length ; x++){
                    //console.log(r[x]);
                    arr.push(r[x].msg);
                }
                tempCommentListDispatch({
                    type: ACTIONS.TEXT_SET_ERRORS,
                    errors: arr,
                    name: event.id
                });
                return false;
            }
            else{
                return true;
            }
        });
        
    }

    const saveNewComment = (e) => {
        const currentTarget = e.currentTarget; 
        e.stopPropagation();
        var d = getCommentTempInputData(tempCommentList,event.id,"input");
        config.isDebugEnabled && console.log("%c%s - %cSave New Comment%c - %s - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, d!=null ?  d.value: null, currentTarget);
        //console.log("Save New Comment - ", event.itemNum, "Text - ", d!=null ?  d.value: null,  currentTarget);
        if(d!=null){
            
            validateCommentAPI(d.value,categoryId,event.id,false,event.id).then(res => {
                var r = getErrorList(res);
                
                if(r!=null && r.length>0){
                    var arr = [];
                    for(var x = 0 ; x<r.length ; x++){
                        //console.log(r[x]);
                        arr.push(r[x].msg);
                    }
                    tempCommentListDispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        errors: arr,
                        name: event.id
                    });
                   
                }
                else{
                    commentsListDispatch({
                        type: "add-comment",
                        input: d,
                        item: event,
                        date: new Date(),
                        isArr: arrItem
                    });
                    tempCommentListDispatch({
                        type: "update-comment-status",
                        name: event.id,
                        status: 'view'
                    })
                    setInputVisible(true);
                    setActiveCommentKey(null);
                }
            }).catch((err)=>{
                setStatusData({
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    message: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                })
                setStatusVariant("error");
                setShowStatusPopup(true); 
            });
        }
        // if(d!=null && validate(d.value)==true){
            
        //     commentsListDispatch({
        //         type: "add-comment",
        //         input: d,
        //         item: event,
        //         date: new Date(),
        //         isArr: arrItem
        //     });
        //     tempCommentListDispatch({
        //         type: "update-comment-status",
        //         name: event.id,
        //         status: 'view'
        //     })
        //     setInputVisible(true);
        //     setActiveCommentKey(null);
        // }
    }

    const deleteComment = (e) => {
        const currentTarget = e.currentTarget; 
        e.stopPropagation();
        //console.log("Delete Comment - ", event.itemNum, currentTarget);
        config.isDebugEnabled && console.log("%c%s - %cDelete Comment%c - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, currentTarget);

       
        setStatusData({
            title: "Delete Comment",
            message: "Are you sure you want to delete this comment?",
            buttons: [
                
                {
                    text: "Yes",
                    action: ()=>{
                        tempCommentListDispatch({
                            type: "remove-comment",
                            id: event.id
                        })
                        
                        commentsListDispatch({
                            type: "remove-comment",
                            id: event.id,
                            isArr: arrItem
                        }) 
                        setActiveCommentKey(null);
                        setInputVisible(false);
                        handleStatusClose();
                    },
                    variant: "comp-primary",
                    size: "lg",
                },
                {
                    text: "No",
                    action: handleStatusClose,
                    variant: "comp-outline",
                    size: "lg"
                },
            ]
        })
        setStatusVariant("warning");
        setShowStatusPopup(true); 
        
        
    
        
    }
    const editComment = (e) => {
        const currentTarget = e.currentTarget; 
        e.stopPropagation();
        config.isDebugEnabled && console.log("%c%s - %cSave Updated Comment%c - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, currentTarget);

        var d = getCommentTempInputData(tempCommentList,event.id,"input");
        if(d!=null){
            var checkEmpty = true;
            validateCommentAPI(d.value,categoryId,event.id,false,event.id).then(res => {
                var r = [];
                config.isDebugEnabled && console.log(res);
                if(res?.data){
                    var codes = res.data.errorCodeList;
                    var messages = res.data.errorMessageList;
                    for(var x = 0 ; x<codes.length ; x++){
                        var c = codes[x];
                        if(c!=null){
                            var split = c.split("_");
                            //console.log(split);
                            if(split.length>1){
                                if(split[1]==200 && checkEmpty!=null && checkEmpty==false){
                                    //return [];
                                }
                                else{
                                    r.push({code: split[1], msg: messages[x]});
                                }
                                
                            }
                        }
                        
                    }
                    if(r!=null && r.length>0){
                        var arr = [];
                        for(var x = 0 ; x<r.length ; x++){
                            //console.log(r[x]);
                            arr.push(r[x].msg);
                        }
                        tempCommentListDispatch({
                            type: ACTIONS.TEXT_SET_ERRORS,
                            errors: arr,
                            name: event.id
                        });
                        
                    }
                    else{
                        if(commentsMatch(commentData.input.value, d.value) != true){
                            commentsListDispatch({
                                type: "update-comment",
                                input: d,
                                item: event,
                                date: new Date(),
                                isArr: arrItem
                            })
                        }
                        tempCommentListDispatch({
                            type: "update-comment-status",
                            name: event.id,
                            status: "view"
                        })
                        setInputVisible(true);
                    }

                    

                }
            }).catch((err)=>{
                setStatusData({
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    message: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                })
                setStatusVariant("error");
                setShowStatusPopup(true); 
            });
            
                
        }
        
    }

    // const handleSaveNewComment = (e,event) => {
    //     console.log(event);
    //     if(event.commentable == 1){
    //         saveNewComment();
    //     }
    // };

    const handleEdit = (event) => {
        // if(event.commentable == 1){
        //     editComment();
        // }
    };

    const handleEditCancel = (e) => {
        const currentTarget = e.currentTarget; 
        e.stopPropagation();
        config.isDebugEnabled && console.log("%c%s - %cCancel Edit Comment%c - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, currentTarget);
        var d = getCommentTempInputData(tempCommentList,event.id,"input");
        setInputVisible(true);
        tempCommentListDispatch({
            type: "update-comment-status",
            name: event.id,
            status: "view"
        })
        tempCommentListDispatch({
            type: ACTIONS.TEXT_AREA_CHANGE,
            value: commentData.input.value,
            maxLength: 2000,
            name: d.name
        });
        setActiveCommentKey(null);
        //console.log(activeCommentKey);
    };

    const handleCloseAdd = (e) => {
        const currentTarget = e.currentTarget; 
        e.stopPropagation();
        config.isDebugEnabled && console.log("%c%s - %cCancel Add New Comment%c - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, currentTarget);
        
        tempCommentListDispatch({
            type: "remove-comment",
            id: event.id
        })
        setActiveCommentKey(null);
    };
 
    //Set focus on input when comment state is edit or add
    useEffect(() => {
        var d = getCommentTempInputData(tempCommentList,event.id,"input");
        config.isDebugEnabled && console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, commentState, event.itemNum, d);
        if (d!=null && d.EditRef.current) {
            (d.EditRef.current).focus();
        }
        if (d!=null && d.InputRef.current) {
            (d.InputRef.current).focus();
        }
        if (d!=null && d.ErrorRef.current) {
            (d.ErrorRef.current).focus();
        }
    }, [commentState,inputVisible]); 

    const getCommentInputArea = () =>{
        var d = getCommentTempInputData(tempCommentList,event.id,"input");
        if(commentsList.hasOwnProperty(event.id)==false && d!=null){
            return (
                <Collapse  in={inputVisible} appear={true} dimension={'height'}>
                    <div className="comment arrItemInput bg-color-base-lightgray shadow2 d-flex flex-column">
                        <Form.Group as={Col}  className="d-flex flex-column">
                            <div className="">
                                <div className="">
                                    <Form.Control
                                        //id="ct-feedback-text"
                                        name={d.name}
                                        as="textarea"
                                        className="ct-comment-input"
                                        isInvalid={d.validation.isInvalid ? "invalid" : ""}
                                        aria-label={d.display.title}
                                        //onChange={(e)=>handleInputTextAreaChange(e)}
                                        onInput={(e)=>handleInputTextAreaChange(e)}
                                        rows={8}
                                        placeholder={"Add your comment..."}
                                        value={d.value}
                                        maxLength={d.display.maxLength}
                                        //minLength={25}
                                        //cols={90}
                                        ref={d.InputRef}
                                    >
                                    </Form.Control>
                                </div>
                                <Form.Text className="d-flex regular justify-content-end bodyXS lh-sm color-base-darkergray">
                                    <ItemCommentCount count={d.count}></ItemCommentCount>
                                </Form.Text>
                                <Form.Control.Feedback ref={d.ErrorRef} className={d.validation.isInvalid ? "is-invalid bodyS" : "bodyS"} type="invalid">
                                    {displayErrors(d.name, d.validation.errors) }
                                </Form.Control.Feedback>
                            </div>
                        </Form.Group>
                        <Stack className="pt-0 justify-content-end flex-column flex-sm-row" direction="horizontal" gap={3}>
                            {/* Submit Button */}
                            <TextButton
                                variant="comp-primary"
                                size="sm"
                                onClick={(e) => saveNewComment(e)}
                                content={"Add Comment"}
                                className="w-xs-100 w-sm-fit-content px-3 "
                                //ref={saveBtnRef}
                                disabled={d.count < 25 ? true : false}
                            >
                            </TextButton>

                            {/* Clear Button */}
                            <TextButton
                                variant="comp-plain"
                                size="sm"
                                onClick={handleCloseAdd}
                                content={"Cancel"}
                                className="w-xs-100 w-sm-fit-content px-3"
                                //disabled={isLoading != true && isLoadingSubmit != true ? false : true}
                            >
                            </TextButton>
                        </Stack>
                    </div>  
                </Collapse>
            )
        }
        else{
            var exists = commentsList.hasOwnProperty(event.id);
            var i = exists ? (commentsList[event.id]).hasOwnProperty('date') : null;
            var date = i != null ? commentsList[event.id]['date'] : '';
            
            if((commentState=="view" || commentState=="edit" )&& d != null ){
                
                    return (
                        <Col 
                            as={commentState=='view' ? "button" : Col}
                            onClick={(e)=>{
                                const currentTarget = e.currentTarget; 
                                if(commentState=='view' && mobile==false){
                                    config.isDebugEnabled && console.log("%c%s - %cEdit Comment%c - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, currentTarget);
                                    
                                    var success = handleActiveCommentChange(event.id).then(res=>{
                                        if(res==true){
                                            tempCommentListDispatch({
                                                type: "update-comment-status",
                                                name: event.id,
                                                status: "edit"
                                            })
                                        }
                                    });
                                }
                                if(commentState=='view' && mobile==true){
                                    setShowControls(true);
                                }
                                
                            }}
                            //disabled={mobile==true}
                            className={"comment arrItemInput shadow2 bg-color-primary-lightblue d-flex flex-column " + (commentState=='view' ?' ct-btn-div view-state' : 'edit-state') + (mobile==true ? ' mobile': '')}
                        >
                            {
                                commentState=='edit'
                                ?
                                        <>
                                        <div className="d-flex flex-column gap-2">
                                            <div className="d-flex flex-row justify-content-between">
                                                <div>
                                                    <p className="bodyS mb-0 color-base-darkgray regular">{date!=null ? getFormattedDate(date) : null}</p>
                                                </div>
                                            </div>

                                            <Form.Group as={Col}  className="d-flex flex-column">
                                                <div className="">
                                                    <div className="">
                                                        <Form.Control
                                                            //id="ct-feedback-text"
                                                            name={d.name}
                                                            as="textarea"
                                                            className="ct-comment-input"
                                                            aria-label={"Edit comment for " + event.itemNum}
                                                            //onChange={(e)=>handleInputTextAreaChange(e)}
                                                            onInput={(e)=>handleInputTextAreaChange(e)}
                                                            placeholder={"Add your comment..."}
                                                            value={d.value}
                                                            maxLength={d.display.maxLength}
                                                            //ref={editRef}
                                                            ref={d.EditRef}
                                                            //minLength={25}
                                                            //cols={90}

                                                        >

                                                        </Form.Control>
                                                    </div>
                                                    <Form.Text className="d-flex regular justify-content-end bodyXS lh-sm color-base-darkergray">
                                                        <ItemCommentCount count={d.count}></ItemCommentCount>
                                                    </Form.Text>
                                                    <Form.Control.Feedback ref={d.ErrorRef} className={d.validation.isInvalid ? "is-invalid bodyS" : "bodyS"} type="invalid">
                                                        {displayErrors(d.name, d.validation.errors) }
                                                        
                                                    </Form.Control.Feedback>
                                                </div>
                                            </Form.Group>
                                            
                                        </div>
                                                                

                                        
                                        <Stack className="pt-0 justify-content-end flex-column flex-sm-row" direction="horizontal" gap={3}>
                                            {/* Submit Button */}
                                            <TextButton
                                                variant="comp-primary"
                                                size="sm"
                                                onClick={(e) => editComment(e)}
                                                content={"Update Comment"}
                                                className="w-xs-100 w-sm-fit-content px-3"
                                                //ref={saveBtnRef}
                                                disabled={d.count < 25 ? true : false}
                                                //disabled={isLoading != true && isLoadingSubmit != true ? false : true}
                                            >
                                            </TextButton>

                                            {/* Clear Button */}
                                            <TextButton
                                                variant="comp-plain"
                                                size="sm"
                                                onClick={(e)=>handleEditCancel(e)}
                                                content={"Cancel"}
                                                className="w-xs-100 w-sm-fit-content px-3"
                                                //disabled={isLoading != true && isLoadingSubmit != true ? false : true}
                                            >
                                            </TextButton>
                                        </Stack>
                                        </>
                                    
                                    
                                    :   null
                                }
                                
                                {
                                commentState=='view'
                                ?
                                <>
                                    <div className="d-flex flex-row justify-content-between">
                                        <div>
                                            <p className="bodyS mb-0 color-base-darkgray semilight">{date!=null ? getFormattedDate(date) : null}</p>
                                        </div>
                                        <div className="controls d-flex flex-row justify-content-end gap-2">
                                            <button
                                                title="Edit comment"
                                                className="edit"
                                                onClick={(e)=>{
                                                    const currentTarget = e.currentTarget;                                                     
                                                    config.isDebugEnabled && console.log("%c%s - %cEdit Comment%c - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, currentTarget);

                                                    e.stopPropagation();
                                                        
                                                    var success = handleActiveCommentChange(event.id).then(res=>{
                                                        if(res==true){
                                                            tempCommentListDispatch({
                                                                type: "update-comment-status",
                                                                name: event.id,
                                                                status: "edit"
                                                            })
                                                        }
                                                    });
                                                    
                                                }}
                                                aria-label={"Edit Comment"}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                    <path d="M0 18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525V18.0025ZM2 15.0825L11.06 6.0225L11.98 6.9425L2.92 16.0025H2V15.0825Z" fill="#0C6DB0"/>
                                                    <path d="M15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925Z" fill="#0C6DB0"/>
                                                </svg>
                                                <span class="visually-hidden">Edit Comment</span>
                                            </button>
                                            <button 
                                                title="Delete comment"
                                                className="delete"
                                                onClick={deleteComment}
                                                aria-label={"Delete Comment"}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                                    <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#DC3545"/>
                                                </svg>
                                                <span class="visually-hidden">Delete Comment</span>
                                            </button>
                                        </div>
                                    </div>
                                    <p className="mb-0 color-base-black body semilight">{d!=null ? d.value : null}</p>
                                    <Form.Control.Feedback ref={d.ErrorRef} className={d.validation.isInvalid ? "is-invalid bodyS" : "bodyS"} type="invalid">
                                        {displayErrors(d.name, d.validation.errors) }
                                        
                                    </Form.Control.Feedback>
                                </>
                                : null
                            }
                        </Col>   
                         
                       
                    )
                }
        } 
    }

    return (
        <>
            {   
                event.commentable == 1 && inputVisible == true && getCommentTempInputData(tempCommentList,event.id) !=null
                ?   
                    getCommentInputArea()
                :   null
            }
        </>
    );
}

export default ItemComment;